var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGameLostForm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 16,
    fill: "url(#paint0_linear_482_3752)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 20.6667C14.5 21.9553 15.5447 23 16.8333 23H19C20.3807 23 21.5 21.8807 21.5 20.5C21.5 19.1193 20.3807 18 19 18H17C15.6193 18 14.5 16.8807 14.5 15.5C14.5 14.1193 15.6193 13 17 13H19.1667C20.4553 13 21.5 14.0447 21.5 15.3333M18 11.5V13M18 23V24.5M28 18C28 23.5228 23.5228 28 18 28C12.4772 28 8 23.5228 8 18C8 12.4772 12.4772 8 18 8C23.5228 8 28 12.4772 28 18Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_482_3752",
    x1: 18,
    y1: -0.00000107288,
    x2: 18,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#008500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#008500"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameLostForm);
export default __webpack_public_path__ + "static/media/game-lost-form.f3f075d111b33f9abd3b0dad6a10a686.svg";
export { ForwardRef as ReactComponent };